import React, { useContext } from 'react';

import CanvasCard from '../../Visualisations/CanvasCard';
import { ChartTopBar } from '../../Chart';
import DashboardGadgetBottomBar from '../../DashboardGadgetBottomBar';
import DashboardGadgetContext from '../../../contexts/DashboardGadgetContext';
import DonutContent from './DonutContent';

const DonutContainer = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      topBar={<ChartTopBar chartDefinition={chartDefinition} />}
      content={
        <DonutContent
          chartDefinition={chartDefinition}
          chartRef={chartRef}
          useSmallNoDataMessage={useSmallNoDataMessage}
        />
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
    />
  );
};

export default DonutContainer;
